import {
   Guardian,
   GuardianCreateCommand,
   PatientAlreadyExistsFault,
   PatientCreateCommand,
} from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, usePush } from '@dreryk/react-components';

import { patientPaths } from '~libs.desktop.shared.paths';

import { PersonalDataFormBean } from '../../common/common.types';
import {
   guardianBaseCommandDataCommandTransformer,
   patientPersonalDataCommandTransformer,
} from '../../common/common.utils';
import { GuardianModalFormBean } from '../../common/GuardianModal/GuardianModal.types';
import { patientTranslationKeys } from '../../translations';
import { usePatientAlreadyExistsFaultHandler } from '../../common/common.hooks';

export const useGoToPatient = (): ((patientId: number) => void) => {
   const push = usePush();

   return (patientId: number) => push(patientPaths.getDataPath(patientId));
};

export const usePatientCreateCommand = (): UseCqrsCommandResult<number, PersonalDataFormBean> => {
   const patientAlreadyExistsFaultHandler = usePatientAlreadyExistsFaultHandler();

   return useCqrsCommand<number, PersonalDataFormBean, PatientAlreadyExistsFault>(
      (parameters) => {
         const command = new PatientCreateCommand();
         patientPersonalDataCommandTransformer(command, parameters);
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(patientTranslationKeys.patientDataCreated);
         },
         onFault: {
            'egabinet-patient-frontend-api:PatientAlreadyExistsFault': patientAlreadyExistsFaultHandler,
         },
      }
   );
};

export const useGuardianCreateCommand = (): UseCqrsCommandResult<
   Guardian,
   { bean: GuardianModalFormBean; patientId: number }
> => {
   return useCqrsCommand((parameters) => {
      const command = new GuardianCreateCommand();
      guardianBaseCommandDataCommandTransformer(command, parameters.bean);
      command.patientId = parameters.patientId;
      return command;
   });
};
